import Dialog from '@mui/material/Dialog';
import { btnsBox, closeBtn, dialogContent, dialogContentBoxes, dialogTitle, paperProps } from './RequisiteModal.sx';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Button, DialogActions, Divider, Snackbar, Typography } from '@mui/material';
import CloseIcon from 'app/components/Icons/CloseIcon';
import DialogContent from '@mui/material/DialogContent';
import React from 'react';
import CopyIcon from 'app/components/Icons/CopyIcon';
import { black1, green, green1, grey10 } from 'app/components/ThemeProvider/colors';
import FileIcon from 'app/components/Icons/FileIcon';
import useRequisiteModal from 'app/components/RequisiteModal/useRequisiteModal';
import CustomInput from 'app/components/CustomInput';
import axios from 'axios';

interface Props {
  accountValue: string;
  accountCurrency: string;
}

const RequisiteModal = (props: Props) => {
  const { accountValue, accountCurrency } = props;
  const {
    t,
    setShowRequisiteModal,
    showRequisiteModal,
    isLoadingRequisite,
    dataRequisite,
    handleOnClickRequisite,
    handleClickDownload,
    isSuccessRequisitePdf,
    dataRequisitePdf,
    showSnackbar,
    handleCopy,
    setShowSnackbar,
  } = useRequisiteModal({
    accountCurrency,
    accountValue,
  });
  // if (isLoadingRequisite) {
  //   return (
  //     <Button color={'tertiary'} sx={{ display: 'flex', gap: '12px' }} onClick={handleOnClickRequisite}>
  //       <FileIcon />
  //       Rekvizitlər
  //     </Button>
  //   );
  // } else {

  return (
    <>
      <Button color={'tertiary'} sx={{ display: 'flex', gap: '12px' }} onClick={handleOnClickRequisite}>
        <FileIcon />
        {t('homePage.requisite')}
      </Button>
      {!isLoadingRequisite && (
        <Dialog
          open={showRequisiteModal}
          PaperProps={{
            sx: paperProps,
          }}
          onClose={() => setShowRequisiteModal(false)}
        >
          <DialogTitle sx={dialogTitle}>
            <Typography sx={{ fontSize: '26px', fontWeight: 600 }}>{t('homePage.requisite')}</Typography>
            <Button
              color={'tertiary'}
              onClick={() => {
                setShowRequisiteModal(false);
              }}
              sx={closeBtn}
            >
              <CloseIcon />
            </Button>
          </DialogTitle>
          <DialogContent sx={dialogContent}>
            <Box sx={dialogContentBoxes}>
              <CustomInput title={t('homePage.account')} value={accountValue} width={'100%'} disabled={true} />
            </Box>
            <Divider />
            <Box sx={dialogContentBoxes} id={'requisiteData'}>
              {dataRequisite?.bank_details.map((item: any) => (
                <Box sx={{ display: 'flex', gap: '8px', flexDirection: 'column' }} key={item.title}>
                  <Typography sx={{ fontSize: '15px', color: 'rgba(20, 25, 31, 0.60)', fontWeight: '400' }}>
                    {item.title}:
                  </Typography>
                  <Typography sx={{ fontSize: '16px', color: black1, fontWeight: '500' }}>{item.value}</Typography>
                </Box>
              ))}
            </Box>
          </DialogContent>
          <DialogActions sx={{ justifyContent: 'flex-start', pl: '40px', pb: '40px' }}>
            <Box sx={btnsBox}>
              <Button onClick={handleClickDownload}>{t('homePage.download')}</Button>
              {isSuccessRequisitePdf && (
                <a href={`${dataRequisitePdf.doc_url}`} id="file" target="_blank" rel="noreferrer"></a>
              )}
              <Button
                color={'tertiary'}
                sx={{
                  display: 'flex',
                  gap: '12px',
                  position: 'relative',
                  '& .MuiSvgIcon-root': { width: '22px', height: '22px' },
                }}
                onClick={handleCopy}
              >
                <CopyIcon />
                {t('homePage.copy')}
                <Snackbar
                  open={showSnackbar}
                  autoHideDuration={1000}
                  onClose={() => setShowSnackbar(false)}
                  message={t('homePage.copied')}
                  sx={{
                    position: 'absolute',
                    bottom: '50px !important',
                    left: '12% !important',

                    '& .MuiPaper-root': {
                      backgroundColor: green1,
                      color: green,
                      minWidth: 'fit-content',
                      fontFamily: 'Yelo',
                      height: '46px',
                    },
                  }}
                />
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
  // }
};

export default RequisiteModal;
